<script>
    import {pop} from 'svelte-spa-router';
    import ModelForm from '../Forms/ModelForm.svelte';

    export let params;
    const object_type = "assessmentType";
    const returnURL = '#/assessmentTypes/'
</script>

<ModelForm {params} {object_type} {returnURL} on:save={pop} on:delete={pop} />